export default __webpack_public_path__ + "static/silver-fern-51a3514366df3093d1e172c1fc5e6ded.png";